// src/app/admindashobard/components/AdminTopbar.jsx

import * as React from "react";
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  IconButton,
  InputBase,
  Paper,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

import { Colors } from "../../utils/Colors";
import AdminProfileMenu from "./AdminProfileMenu";

export default function AdminTopbar({ onMenuClick }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpenProfileMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseProfileMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: Colors.bg.paper,
          color: Colors.text.header,
          borderBottom: `1px solid ${Colors.border.light}`,
          boxShadow: "none",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          sx={{
            minHeight: 74,
            px: { xs: 2, md: 3 },
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2} sx={{ flex: 1 }}>
            <IconButton
              onClick={onMenuClick}
              sx={{
                color: Colors.text.icon,
                "&:hover": { bgcolor: Colors.bg.hover },
              }}
            >
              <MenuIcon />
            </IconButton>

            <Paper
              elevation={0}
              sx={{
                display: "flex",
                alignItems: "center",
                width: { xs: "100%", sm: 360, md: 480, lg: 620 },
                maxWidth: "100%",
                height: 44,
                px: 2,
                borderRadius: 2,
                border: `1px solid ${Colors.border.input}`,
                bgcolor: Colors.bg.paper,
              }}
            >
              <SearchIcon
                sx={{
                  color: Colors.brand.primary,
                  mr: 1.2,
                  fontSize: 22,
                }}
              />
              <InputBase
                fullWidth
                placeholder="Search patient name or ID"
                sx={{
                  fontSize: 15,
                  color: Colors.text.body,
                  "& input::placeholder": {
                    color: Colors.text.placeholder,
                    opacity: 1,
                  },
                }}
              />
            </Paper>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={2}>
            <IconButton sx={{ color: Colors.text.icon }}>
              <Badge
                color="warning"
                variant="dot"
                overlap="circular"
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <NotificationsNoneRoundedIcon sx={{ fontSize: 24 }} />
              </Badge>
            </IconButton>

            <Stack
              direction="row"
              alignItems="center"
              spacing={1.2}
              sx={{ cursor: "pointer" }}
              onClick={handleOpenProfileMenu}
            >
              <Avatar
                sx={{
                  width: 38,
                  height: 38,
                  bgcolor: "#c9cdcf",
                  color: "#fff",
                  fontWeight: 700,
                }}
              >
                F
              </Avatar>

              <Box>
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: Colors.brand.primary,
                    lineHeight: 1.1,
                  }}
                >
                  Fludee Admin
                </Typography>
                <Typography
                  sx={{
                    fontSize: 13,
                    color: Colors.text.sub,
                    mt: 0.2,
                  }}
                >
                  Super Admin
                </Typography>
              </Box>

              <KeyboardArrowDownRoundedIcon sx={{ color: Colors.text.icon }} />
            </Stack>
          </Stack>
        </Toolbar>

        <Box
          sx={{
            height: 10,
            bgcolor: Colors.brand.accentBar,
            borderTop: `1px solid ${Colors.border.topLine}`,
          }}
        />
      </AppBar>

      <AdminProfileMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseProfileMenu}
      />
    </>
  );
}